; (function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('ActivityItemController', ActivityItemController)

  /* @ngInject */
  function ActivityItemController ($scope, $rootScope, $translate, $filter, EmojisService, Utils) {
    let itemType = ''

    const api = {
      _getEmoji,
      _getAuditActivityText,
      _getTaskActivityText,
      _getArtActivityText
    }
    this.getApi = () => api

    activate()

    function activate () {
      if ($scope.activity.auditId) {
        itemType = 'audit'
      } else if ($scope.activity.taskId) {
        itemType = 'task'
        if ($scope.activity.type === 'REACTION') {
          api._getEmoji()
        }
      } else if ($scope.activity.artId) {
        itemType = 'art'
      }
      if (!$scope.activity.author.name) {
        $scope.activity.author.name = $translate.instant('taskHistoryMsgs.system')
      }
    }

    $scope.getActivityText = function (activity) {
      const type = activity.type
      const operation = activity.operation

      if ((!type || !operation) && itemType !== 'art') {
        return ''
      }

      if (itemType === 'audit') {
        return api._getAuditActivityText(activity)
      }

      if (itemType === 'task') {
        return api._getTaskActivityText(activity)
      }

      if (itemType === 'art') {
        return api._getArtActivityText(activity)
      }
    }

    function _getEmoji () {
      EmojisService.getEmojis([$scope.activity.to]).then(emoji => {
        $scope.reaction = Utils.mapPropertyToSafeValue(emoji, 'code')
      })
    }

    function _getAuditActivityText (activity) {
      const type = activity.type
      const operation = activity.operation
      const value = activity.to

      switch (true) {
        case type === 'STATUS' && operation === 'CREATE':
          return $translate
            .instant('auditHistoryMsgs.create')
            .replace('$company', `<span class="text-bold">${$rootScope.oUserCompany.formattedName}</span>`)
            .replace('$user', `<span class="text-bold">${$rootScope.oUser.name}</span>`)
        case type === 'STATUS' && operation === 'UPDATE' && value === 'ANALYZE':
          return $translate.instant('auditHistoryMsgs.analyze')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'ACTION':
          return $translate.instant('auditHistoryMsgs.action')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'FINISHED':
          return $translate.instant('auditHistoryMsgs.finished')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'EXPIRED':
          return $translate.instant('auditHistoryMsgs.expired')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'NONCONFORM':
          return $translate.instant('auditHistoryMsgs.nonconform')
        case type === 'SCORE' && operation === 'UPDATE':
          return $translate.instant('auditHistoryMsgs.review') + ` <span class="text-bold">${value || activity['audit.score']}</span>`
        case type === 'DATE' && operation === 'UPDATE':
          return $translate.instant('auditHistoryMsgs.date') + ` <span class="text-bold">${$filter('dateFilter')(value)}</span>`
      }
    }

    function _getTaskActivityText (activity) {
      const type = activity.type
      const operation = activity.operation
      const value = activity.to
      const briefingUpdateDescription = activity.briefingUpdateDescription
      const from = activity.from
      const isSubtask = activity.isSubtask

      switch (true) {
        case type === 'STATUS' && operation === 'UPDATE' && value === 'REJECTED':
          return $translate.instant('taskHistoryMsgs.rejectedRequest')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'WAITING_RESPONSE' && from !== 'WAITING_PRE_APPROVAL':
          return $translate.instant('taskHistoryMsgs.requestApproval')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'WAITING_RESPONSE' && from === 'WAITING_PRE_APPROVAL':
          return $translate.instant('taskHistoryMsgs.consultantApproval')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'WAITING_ADM_ADJUST':
          return $translate.instant('taskHistoryMsgs.requestAdjusts')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'WAITING_USER_ADJUST':
          return $translate.instant('taskHistoryMsgs.requestAdjusts')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'REVIEW':
          return $translate.instant('taskHistoryMsgs.review')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'INBOX':
          return $translate.instant('taskHistoryMsgs.approvedRequest')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'DONE':
          return $translate.instant('taskHistoryMsgs.done')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'PROGRESS' && !isSubtask:
          return $translate.instant('taskHistoryMsgs.reopenedTask')
        case type === 'STATUS' && operation === 'UPDATE' && value === 'PROGRESS' && isSubtask:
          return $translate.instant('taskHistoryMsgs.reopenedSubtask')
        case type === 'COLUMN' && operation === 'UPDATE' && !activity.columnName:
          return $translate.instant('taskHistoryMsgs.move')
        case type === 'COLUMN' && operation === 'UPDATE' && !isSubtask:
          return $translate.instant('taskHistoryMsgs.moveTo', { columnName: activity.columnName })
        case type === 'COLUMN' && operation === 'UPDATE' && isSubtask:
          return $translate.instant('taskHistoryMsgs.moveToSubtask', { columnName: activity.columnName })
        case type === 'COLUMN' && operation === 'CREATE':
          return $translate.instant('taskHistoryMsgs.moveToBoard', { boardName: activity.boardName })
        case type === 'ARCHIVE' && value === 'true' && !isSubtask:
          return $translate.instant('taskHistoryMsgs.archive')
        case type === 'ARCHIVE' && value === 'true' && isSubtask:
          return $translate.instant('taskHistoryMsgs.archiveSubtask')
        case type === 'ARCHIVE' && value === 'false' && !isSubtask:
          return $translate.instant('taskHistoryMsgs.unarchive')
        case type === 'ARCHIVE' && value === 'false' && isSubtask:
          return $translate.instant('taskHistoryMsgs.unarchiveSubtask')
        case type === 'TITLE' && operation === 'UPDATE' && !isSubtask:
          return $translate.instant('taskHistoryMsgs.title')
        case type === 'TITLE' && operation === 'UPDATE' && isSubtask:
          return $translate.instant('taskHistoryMsgs.titleSubtask')
        case type === 'DESCRIPTION' && (operation === 'UPDATE' || operation === 'CREATE') && isSubtask:
          return $translate.instant('taskHistoryMsgs.descriptionSubtask')
        case type === 'DESCRIPTION' && (operation === 'UPDATE' || operation === 'CREATE') && !isSubtask:
          return $translate.instant('taskHistoryMsgs.description')
        case type === 'PRIORITY' && operation === 'UPDATE' && !isSubtask:
          return $translate.instant('taskHistoryMsgs.priority')
        case type === 'PRIORITY' && operation === 'UPDATE' && isSubtask:
          return $translate.instant('taskHistoryMsgs.prioritySubtask')
        case type === 'DELIVERY_DATE' && (operation === 'UPDATE' || operation === 'CREATE') && !isSubtask:
          return $translate.instant('taskHistoryMsgs.date')
        case type === 'DELIVERY_DATE' && (operation === 'UPDATE' || operation === 'CREATE') && isSubtask:
          return $translate.instant('taskHistoryMsgs.dateSubtask')
        case type === 'ATTACHMENT' && operation === 'CREATE':
          if (activity.attachmentName || activity.from) {
            const attachmentName = activity.attachmentName || activity.from
            return $translate.instant('taskHistoryMsgs.addAttachmentName', { attachmentName })
          } else {
            return $translate.instant('taskHistoryMsgs.addAttachment')
          }
        case type === 'ATTACHMENT' && operation === 'DELETE':
          return $translate.instant('taskHistoryMsgs.deleteAttachment')
        case (type === 'COMENT' || type === 'TASK_COMENT') && operation === 'CREATE':
          return $translate.instant('taskHistoryMsgs.createComment')
        case (type === 'COMENT' || type === 'TASK_COMENT') && operation === 'UPDATE':
          return $translate.instant('taskHistoryMsgs.updateComment')
        case (type === 'COMENT' || type === 'TASK_COMENT') && operation === 'DELETE':
          return $translate.instant('taskHistoryMsgs.deleteComment')
        case type === 'ASSIGNEE' && operation === 'DELETE':
          return $translate.instant('taskHistoryMsgs.removeAssignee')
        case type === 'ASSIGNEE' && operation === 'CREATE':
          return $translate.instant('taskHistoryMsgs.addAssignee')
        case type === 'STATUS' && operation === 'CREATE' && !isSubtask:
          return $translate.instant('taskHistoryMsgs.createTask')
        case type === 'STATUS' && operation === 'CREATE' && isSubtask:
          return $translate.instant('taskHistoryMsgs.createSubtask')
        case type === 'NEW_BRIEFING_VERSION' && operation === 'UPDATE':
          return briefingUpdateDescription ? `${$translate.instant('taskHistoryMsgs.newBriefingVersion')} ${briefingUpdateDescription}` : $translate.instant('taskHistoryMsgs.newBriefingVersion')
        case type === 'REACTION':
          return $translate.instant('taskHistoryMsgs.reaction')
        case type === 'RELATED_TASK' && operation === 'CREATE':
          if (activity.relatedTaskTitle) {
            return $translate.instant('taskHistoryMsgs.addRelatedTaskTitle', { task: activity.relatedTaskTitle })
          } else {
            return $translate.instant('taskHistoryMsgs.addRelatedTask')
          }
        case type === 'RELATED_TASK' && operation === 'DELETE':
          if (activity.relatedTaskTitle) {
            return $translate.instant('taskHistoryMsgs.removeRelatedTaskTitle', { task: activity.relatedTaskTitle })
          } else {
            return $translate.instant('taskHistoryMsgs.removeRelatedTask')
          }
        case type === 'RATING' && operation === 'CREATE':
          return $translate.instant('taskHistoryMsgs.ratedTask', { rate: activity.to })
        case type === 'AUTHOR' && operation === 'UPDATE':
          return $translate.instant('taskHistoryMsgs.changedAuthor', { authorName: activity.authorName })
        case type === 'AUTHOR' && operation === 'CREATE':
          return $translate.instant('taskHistoryMsgs.adminAssignedAuthor', { userName: activity.authorName })
        case type === 'APPROVAL' && operation === 'CREATE':
          return $translate.instant('taskHistoryMsgs.createApproval')
        case type === 'APPROVAL' && operation === 'UPDATE':
          return $translate.instant('taskHistoryMsgs.updateApproval')
        case type === 'APPROVAL' && operation === 'DELETE':
          return $translate.instant('taskHistoryMsgs.deleteApproval')
        case activity.approvalId && type === 'STATUS' && operation === 'UPDATE':
          return $translate.instant('taskHistoryMsgs.statusApproval', { status: $translate.instant(`taskHistoryMsgs.${value}`) })
        case type === 'TIMESHEETS' && operation === 'CREATE':
          return $translate.instant('taskHistoryMsgs.createTimesheet')
        case type === 'TIMESHEETS' && operation === 'UPDATE':
          return $translate.instant('taskHistoryMsgs.updateTimesheet')
        case type === 'TIMESHEETS' && operation === 'DELETE':
          return $translate.instant('taskHistoryMsgs.deleteTimesheet')
        case type === 'START_DATE' && operation === 'UPDATE' && !isSubtask:
          return $translate.instant('taskHistoryMsgs.updateStartDate')
        case type === 'START_DATE' && operation === 'UPDATE' && isSubtask:
          return $translate.instant('taskHistoryMsgs.updateStartDateSubtask')
        case type === 'START_DATE' && operation === 'CREATE' && !isSubtask:
          return $translate.instant('taskHistoryMsgs.createStartDate')
        case type === 'START_DATE' && operation === 'CREATE' && isSubtask:
          return $translate.instant('taskHistoryMsgs.createStartDateSubtask')
      }
    }

    function _getArtActivityText (activity) {
      const statusFrom = activity.statusFrom
      const statusTo = activity.statusTo

      switch (true) {
        case statusFrom === 'DESIGNING' && statusTo === 'PENDING_APPROVAL':
          return $translate.instant('designingToPendingApprovalMsg')
        case statusFrom === 'PENDING_REWORK' && statusTo === 'PENDING_APPROVAL':
          return $translate.instant('pendingReworkToPendingApprovalMsg')
        case statusFrom === 'PENDING_REWORK' && statusTo === 'APPROVED':
          return $translate.instant('statusChangeDefaultMsg', { from: $translate.instant('waitingAdjusts'), to: $translate.instant('approved') })
        case statusFrom === 'PENDING_REWORK' && statusTo === 'REJECTED':
          return $translate.instant('statusChangeDefaultMsg', { from: $translate.instant('waitingAdjusts'), to: $translate.instant('reproved') })
        case statusFrom === 'PENDING_APPROVAL' && statusTo === 'PENDING_REWORK':
          return $translate.instant('pendingApprovalToPendingReworkMsg')
        case statusFrom === 'PENDING_APPROVAL' && statusTo === 'APPROVED':
          return $translate.instant('pendingApprovalToApprovedMsg')
        case statusFrom === 'PENDING_APPROVAL' && statusTo === 'REJECTED':
          return $translate.instant('pendingApprovalToRejectedMsg')
        case statusFrom === 'APPROVED' && statusTo === 'DESIGNING':
          return $translate.instant('approvedToDesigningMsg')
        case statusFrom === 'APPROVED' && statusTo === 'PENDING_REWORK':
          return $translate.instant('statusChangeDefaultMsg', { from: $translate.instant('approved'), to: $translate.instant('waitingAdjusts') })
        case statusFrom === 'APPROVED' && statusTo === 'REJECTED':
          return $translate.instant('statusChangeDefaultMsg', { from: $translate.instant('approved'), to: $translate.instant('reproved') })
        case statusFrom === 'REJECTED' && statusTo === 'APPROVED':
          return $translate.instant('statusChangeDefaultMsg', { from: $translate.instant('reproved'), to: $translate.instant('approved') })
        case statusFrom === 'REJECTED' && statusTo === 'PENDING_REWORK':
          return $translate.instant('statusChangeDefaultMsg', { from: $translate.instant('reproved'), to: $translate.instant('waitingAdjusts') })
        case statusTo === 'TEMPLATE_ARCHIVED':
          return $translate.instant('templateArchivedHistoryMSG')
        case statusTo === 'TEMPLATE_UNARCHIVED':
          return $translate.instant('templateUnarchivedHistoryMSG')
        case statusTo === 'FINISHED_ART_VERSION':
          return $translate.instant('finishedArtVersionMessageHistory')
        case statusTo === 'UPDATE_ART_VERSION':
          return $translate.instant('updateArtVersionMessageHistory')
        case statusTo === 'UPDATE_TEMPLATE':
          return $translate.instant('updateTemplateMessageHistory')
        default:
          return ''
      }
    }
  }
})()
